import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { MdOutlineArrowBackIosNew } from 'react-icons/md'
import { Loader } from 'rsuite';
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import Select from 'react-select';
import DragDropFileUpload from '../CommonComponents/DragDropFileUpload';
import { toast } from '../CommonComponents/ToastComponent/toast'
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import { checkIsPhoneNumberValid, checkIsEmailValid, getStateName, getAbbreviatedState, blobToDataUrl, checkIsAdmin } from '../../services/helper'
import { createPartner, updatePartner, uploadPartnerLogo, getPartnerById } from '../../redux/actions/partner';
import { getCallerScriptsOfPartner } from '../../redux/actions/caller';
import { Progress } from 'rsuite'
import LoaderComponent from '../CommonComponents/LoaderComponent';
import { downloadFileFromS3Bucket } from '../../redux/actions/vendor';
import CreateCallingScriptComponent from '../CreateCallingScriptComponent';
import CallingScriptList from '../CallingScriptList';
import { parsePhoneNumber } from 'awesome-phonenumber';

const CreateOrUpdatePartnerComponent = ({ OnHidePartnerManagement, partnerId = null }) => {
    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        partnerId ?
            history.push('/settings/access/partners/update-partner')
            :
            history.push('/settings/access/partners/upload/create-partner')
    }, [history])

    const partnerGeneralInfoLeftCols = [
        { label: 'Partner Name', name: 'partnerName' },
        { label: 'Primary Contact Name', name: 'contactName' },
        { label: 'Phone No', name: 'phone' },
        { label: 'Email', name: 'email' }
    ]
    const partnerGeneralInfoRightCols = [
        { label: 'Address 1', name: 'address1' },
        { label: 'Address 2', name: 'address2' },
        { label: 'City', name: 'city' },
        { label: 'State', name: 'abbreviatedState' },
        { label: 'Zip', name: 'zip' },
        { label: 'Country', name: 'country' },
    ]
    const partnerPreferencesCols = [
        { label: 'Rebate', name: 'rebate' },
        { label: 'Bin Support', name: 'binSupportValue' },
        { label: 'Card Program Support', name: 'cardProgramSupportValue' },
        { label: 'Automatable', name: 'automatableValue' },
        { label: 'Upload Logo', name: 'logo' }
    ]

    const partnerUserColumns = [
        { label: 'Submission User', name: 'submissionUser' },
        { label: 'Submission User Password', name: 'submissionUserPassword' },
    ]

    const allPartnerColumns = [...partnerGeneralInfoLeftCols, ...partnerGeneralInfoRightCols, ...partnerPreferencesCols, ...partnerUserColumns]
    const binSupportOptions = ['Amex Business', 'Amex Corporate', 'Mastercard Debit', 'Mastercard Credit', 'Mastercard Debit Business', 'Mastercard Maestro', 'Mastercard Cirrus', 'Mastercard Fleet', 'Mastercard World', 'Mastercard World Elite', 'Mastercard Standard Prepaid', 'Mastercard Platinum']
    const cardProgramSupportOptions = ['Amex', 'Visa', 'Mastercard']
    const automatableOptions = ['Email', 'Fax', 'Phone/Credentials', 'Phone/No-Credentials', 'IVR/Credentials', 'IVR/No-Credentials', 'Portal/Credentials', 'Portal/No-Credentials', 'Ecommerce/Credentials', 'Ecommerce/No-Credentials', 'In-App/Credentials', 'In-App/No-Credentials']

    const phoneInputRefname = useRef(null);
    const [partnerInfo, setPartnerInfo] = useState({})
    const [partnerOldInfo, setPartnerOldInfo] = useState({})
    const [isPhoneValid, setIsPhoneValid] = useState('')
    const [isValidatingPhone, setIsValidatingPhone] = useState(false)
    const [countryCode, setCountryCode] = useState('')
    const [isEmailValid, setIsEmailValid] = useState('')
    const [isValidatingEmail, setIsValidatingEmail] = useState(false)
    const [logoFile, setLogoFile] = useState(null)
    const [logoURL, setLogoURL] = useState('')
    const [progress, setProgress] = useState(0)
    const [isCreatingOrUpdatingPartner, setIsCreatingOrUpdatingPartner] = useState(false)
    const [isGettingPartnerDataById, setIsGettingPartnerDataById] = useState(false)
    const [callingScriptInfo, setCallingScriptInfo] = useState({})
    const [defaultScript, setDefaultScript] = useState(null)
    const [callingScripts, setCallingScripts] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [isDefaultScriptId, setIsDefaultScriptId] = useState(null)
    const [checkScriptInfo, setScriptInfo] = useState({})
    const [isDisable, setIsDisable] = useState(true)
    const [newPartnerId, setNewPartnerId] = useState(null)
    const [partnerPage, setPartnerPage] = useState('')
    const [showAddUserModal, setShowAddUserModal] = useState(false)
    const [userValues, setUserValues] = useState({
        userName: '',
        password: ''
    })
    const [showPassword, setShowPassword] = useState(false)
    const location = useLocation()

    useEffect(() => {
        if (location.pathname === "/settings/access/partners/upload/create-partner") {
            setPartnerPage('create')
        } else {
            setPartnerPage("update")
        }
    }, [location])

    const setInitialSupplierInfo = useCallback(async (columns, partnerDetails) => {
        let tmpPartnerInfo = {}
        let partnerColumns = [...columns]
        const usArray = ['united states', 'usa', 'us']

        partnerColumns.push({ name: 'phoneExtension', label: 'Phone Extension' })
        partnerColumns.forEach(column => {
            const tmpValue = partnerDetails ? partnerDetails?.[column.name] : ''
            if (column.name === 'state' || column.name === 'country') {
                tmpPartnerInfo[column.name] = /^[a-zA-Z\s]+$/.test(tmpValue) ? tmpValue : ''
            } else if (column.name === 'phone') {
                tmpPartnerInfo[column.name] = !tmpValue ? '' : tmpValue?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? tmpValue : partnerDetails?.['country'] && usArray.includes(partnerDetails?.['country'].toLowerCase()) && tmpValue.startsWith('1') ? tmpValue : ((partnerDetails?.['country'] && !usArray.includes(partnerDetails?.['country'].toLowerCase()))) ? tmpValue : tmpValue.startsWith('1') ? tmpValue : '1 ' + tmpValue
            }
            else if (column.name === 'zip') {
                tmpPartnerInfo[column.name] = /^\d{5}(-\d{4})?$/.test(tmpValue) ? tmpValue : ''
            } else if (column.name === 'email') {
                tmpPartnerInfo[column.name] = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(tmpValue) ? tmpValue : ''
            } else if (column.name === 'abbreviatedState') {
                let stateCode = ''
                if (partnerDetails?.abbreviatedState === null) {
                    stateCode = getAbbreviatedState(partnerDetails?.abbreviatedState, partnerDetails?.state)
                } else {
                    stateCode = partnerDetails?.abbreviatedState
                }
                tmpPartnerInfo[column.name] = stateCode
            } else if (column.name === 'binSupportValue' || column.name === 'automatableValue' || column.name === 'cardProgramSupportValue') {
                let selectOptions = []
                if ((partnerDetails?.[column.name] && Array.isArray(partnerDetails?.[column.name]))) {
                    selectOptions = partnerDetails?.[column.name]
                } else {
                    const selectOptionsOptionsArray = partnerDetails?.[column.name] === undefined || partnerDetails?.[column.name]?.length === 0 ? [] : partnerDetails?.[column.name] ? partnerDetails?.[column.name]?.split(',') : [];
                    selectOptionsOptionsArray.map((option) => {
                        option = option.replace(/^\s+|\s+$/g, "");
                        selectOptions.push({
                            label: (option[0].toUpperCase() + option.slice(1)).replaceAll('-', ' '),
                            value: option
                        })
                    })
                }
                tmpPartnerInfo[column.name] = selectOptions || []
            } else {
                tmpPartnerInfo[column.name] = tmpValue
            }
        })
        if (partnerId) {
            tmpPartnerInfo["id"] = partnerId
        }
        setPartnerInfo(tmpPartnerInfo)
        setPartnerOldInfo(tmpPartnerInfo)
        setLogoFile(null)
        if (tmpPartnerInfo?.logo) {
            dispatch(
                downloadFileFromS3Bucket({ filename: tmpPartnerInfo?.logo })
            ).then(async (response) => {
                let logoUrl = await blobToDataUrl(response.data)
                setLogoURL(logoUrl)
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: "Unable to load Logo!",
                })
            })
        }
        setLogoURL('')
    }, [])

    useEffect(() => {
        if (!allPartnerColumns || allPartnerColumns.length === 0) {
            return
        }
        if (partnerId) {
            setIsGettingPartnerDataById(true)
            dispatch(getPartnerById({ partnerId })).then((partnerData) => {
                if (partnerData?.defaultCallingScript?.length > 0) {
                    setDefaultScript(partnerData?.defaultCallingScript?.[0])
                } else {
                    setDefaultScript(null)
                }
                setInitialSupplierInfo(allPartnerColumns, partnerData?.partner)
                setIsGettingPartnerDataById(false)
            }).catch(() => {
                setIsGettingPartnerDataById(false)
            })
        } else {
            setInitialSupplierInfo(allPartnerColumns, partnerInfo)
        }
    }, [setInitialSupplierInfo])

    const getAllCallerScripts = () => {
        setIsLoading(true)
        dispatch(getCallerScriptsOfPartner(partnerId ? partnerId : newPartnerId)).then((res) => {
            setIsLoading(false)
            setCallingScripts(res)
            const defaultScript = res.filter((script) => {
                return script?.isDefault === true
            })
            setIsDefaultScriptId(defaultScript[0]?.id)
        }).catch((err) => {
            setIsLoading(false)
            setCallingScripts([])
            setIsDefaultScriptId(null)
        })
    }

    useEffect(() => {
        if (partnerId) {
            getAllCallerScripts()
        }
    }, [])

    const handleChangePartnerInfo = (colName, value) => {
        let tmpValue = value
        if (colName === 'state' || colName === 'country') {
            if (/^[a-zA-Z\s]+$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^[a-zA-Z\s]+/gi) ? value.match(/^[a-zA-Z\s]+/gi)[0] : ''
            }
        } else if (colName === 'zip') {
            if (/^\d{5}(-\d{4})?$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{1,5}(-\d{0,4})?/gi) ? value.match(/^\d{1,5}(-\d{0,4})?/gi)[0] : ''
            }
        } else if (colName === 'email') {
            if (!tmpValue) {
                setIsEmailValid(true)
            } else {
                setIsEmailValid('')
            }
        } else if (colName === 'abbreviatedState') {
            let regex = /^[a-zA-Z\s]{2}$/
            let regex1 = /^[a-zA-Z\s]{1,2}/gi
            if (partnerInfo?.country && (partnerInfo?.country.trim().toLowerCase() === 'australia' || partnerInfo?.country.trim().toLowerCase() === 'aus')) {
                regex = /^[a-zA-Z\s]{3}$/
                regex1 = /^[a-zA-Z\s]{1,3}/gi
            }
            if (regex.test(value)) {
                tmpValue = value.trim().toUpperCase()
            } else {
                tmpValue = value.trim().match(regex1) ? value.trim().match(regex1)[0].toUpperCase() : ''
            }
        } else if (colName === 'phoneExtension') {
            if (/^\d{20}$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{1,20}/gi) ? value.match(/^\d{1,20}/gi)[0] : ''
            }
        } else if (colName === 'rebate') {
            var temp = "";
            temp = value ? parseInt(value.replace(/\D/g, '')) : '';
            temp = isNaN(temp) ? '' : temp
            value = temp ? ((temp) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            if (/^\d{0,2}(\.\d{0,2})?$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{0,2}(\.\d{0,2})?/gi) ? value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
            }
        }
        setPartnerInfo({
            ...partnerInfo,
            [colName]: tmpValue,
        })
    }

    const handleFileChosen = async (file) => {
        if (
            !file
        ) {
            return
        }
        setLogoFile(file)
        const reader = new FileReader()
        reader.onload = () => {
            setLogoURL(reader.result)
        }
        await reader.readAsDataURL(file)
    }

    const handleKeyDown = (e, phoneInputRefname) => {
        if (e.keyCode === 9) {
            phoneInputRefname.current.props.onBlur()
        }
    }

    const handlePhoneNumberFocusOut = async (event, country, phoneValue, isUseEffect = false) => {
        var countryCode = country && country.dialCode
        var phoneValueWithCode = phoneValue
        var phoneNewValue = phoneValue ? '+' + phoneValue : phoneValue
        const phone = parsePhoneNumber(phoneNewValue);
        const isValid = phone?.valid || false
        if (!isValid) {
            setIsPhoneValid(false)
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            return
        }

        if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
            return
        }
        if (phoneValue !== '') {
            setIsValidatingPhone(true)
            phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
            var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
            setIsPhoneValid(phoneValidationResult?.isPhoneValid)
            setIsValidatingPhone(phoneValidationResult?.isValidatingPhone)
        } else {
            setIsPhoneValid(true)
        }
    }

    const handlePhoneInputChange = (value, country, e, formattedValue) => {
        var phoneValue = formattedValue.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '').replace(/[^\w\s]|[\s]/gi, '')
        var countrycode = country.dialCode + ' '
        if (phoneValue !== '') {
            phoneValue = countrycode + phoneValue
            setIsPhoneValid('')
        } else {
            phoneValue = country.dialCode
            setIsPhoneValid(true)
        }
        if (e.target === null) {
            handlePhoneNumberFocusOut(e, country, formattedValue)
        }
        setCountryCode(country.dialCode)
        setPartnerInfo({
            ...partnerInfo,
            'phone': phoneValue === '' ? '' : phoneValue,
        })
    }

    const handleEmailFocusOut = async (emailValue) => {
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            setIsEmailValid(false)
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!'
            })
            return
        }
        if (emailValue && emailValue !== '') {
            setIsValidatingEmail(true)
            var emailValidationResult = await checkIsEmailValid(emailValue, dispatch)
            setIsEmailValid(emailValidationResult?.isEmailValid)
            setIsValidatingEmail(emailValidationResult?.isValidatingEmail)
        } else {
            setIsEmailValid(true)
        }
    }

    const handleSaveSupplierInfo = () => {
        if (!partnerInfo?.partnerName) {
            toast.show({
                title: 'Warning',
                description: 'Partner name shouldn\'t be empty!',
            })
            return
        }
        if (countryCode === partnerInfo?.phone) {
            partnerInfo['phone'] = ''
        }

        if (isValidatingPhone) {
            toast.show({
                title: 'Warning',
                description: 'validating phone number...!',
            })
            return
        }
        if (isValidatingEmail) {
            toast.show({
                title: 'Warning',
                description: 'validating email...!',
            })
            return
        }

        if (!isEmailValid && isEmailValid !== '') {
            toast.show({
                title: 'Warning',
                description: 'Invalid Email'
            })
            return
        }
        if (isPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Phone Number.'
            })
            return
        }

        if (partnerInfo?.abbreviatedState && partnerInfo?.abbreviatedState !== '') {
            let regex = /^[a-zA-Z\s]{2}$/
            let stateChars = 2
            if (partnerInfo?.country && (partnerInfo?.country.trim().toLowerCase() === 'australia' || partnerInfo?.country.trim().toLowerCase() === 'aus')) {
                regex = /^[a-zA-Z\s]{2,3}$/
                stateChars = '2 or 3'
            }
            if (!regex.test(partnerInfo?.abbreviatedState.trim())) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid State. Must be ' + stateChars + ' characters long!'
                })
                return
            } else {
                partnerInfo['state'] = getStateName(partnerInfo?.abbreviatedState)
            }
        }

        // if (!callingScriptInfo?.title) {
        //     toast.show({
        //         title: 'Warning',
        //         description: "Script title shouldn't be empty!",
        //     })
        //     return
        // }
        // if (!callingScriptInfo?.script) {
        //     toast.show({
        //         title: 'Warning',
        //         description: "Calling script shouldn't be empty!",
        //     })
        //     return
        // }

        const tmpPartnerInfo = JSON?.parse(JSON?.stringify(partnerInfo))
        tmpPartnerInfo['binSupportValue'] = tmpPartnerInfo?.binSupportValue ? tmpPartnerInfo?.binSupportValue?.map(option => option?.value)?.join(",") : ''
        tmpPartnerInfo['automatableValue'] = tmpPartnerInfo?.automatableValue ? tmpPartnerInfo?.automatableValue?.map(option => option?.value)?.join(",") : ''
        tmpPartnerInfo['cardProgramSupportValue'] = tmpPartnerInfo?.cardProgramSupportValue ? tmpPartnerInfo?.cardProgramSupportValue?.map(option => option?.value)?.join(",") : ''

        if (logoFile && logoFile.name) {
            setIsCreatingOrUpdatingPartner(true)
            dispatch(
                uploadPartnerLogo(logoFile, (event) => {
                    setProgress(Math.round((100 * event.loaded) / event.total))
                })
            ).then((response) => {
                toast.show({
                    title: 'Success',
                    description: response.data.message,
                })
                tmpPartnerInfo.logo = response.data.generatename
                dispatchCreateOrUpdatePartner(tmpPartnerInfo)
            }).catch(() => {
                setIsCreatingOrUpdatingPartner(false)
            })
        } else {
            setIsCreatingOrUpdatingPartner(true)
            dispatchCreateOrUpdatePartner(tmpPartnerInfo)
        }
        setIsDisable(false)
    }

    const dispatchCreateOrUpdatePartner = (partnerInfo) => {
        dispatch(
            (partnerId || newPartnerId) ? updatePartner({
                partnerData: {
                    ...partnerInfo,
                    id: newPartnerId ? newPartnerId : partnerId
                }
            }) :
                createPartner({
                    partnerData: {
                        ...partnerInfo,
                    }
                })
        ).then((partner) => {
            setNewPartnerId(newPartnerId ? partner?.['partnerData']?.id : partner?.['partnerData']?.id)
            setIsGettingPartnerDataById(true)
            dispatch(getPartnerById({ partnerId: newPartnerId ? partner?.['partnerData']?.id : partner?.['partnerData']?.id })).then((partnerData) => {
                if (partnerData?.defaultCallingScript?.length > 0) {
                    setDefaultScript(partnerData?.defaultCallingScript?.[0])
                } else {
                    setDefaultScript(null)
                }
                setInitialSupplierInfo(allPartnerColumns, partnerData?.partner)
                setIsGettingPartnerDataById(false)
            }).catch(() => {
                setIsGettingPartnerDataById(false)
            })

            // if (partner?.defaultCallingScript?.length > 0) {
            //     setDefaultScript(partner?.defaultCallingScript?.[0])
            // } else {
            //     setDefaultScript(null)
            // }
            // setInitialSupplierInfo(allPartnerColumns, (partnerId || newPartnerId) ? partner['partnerData'] : partner)
            toast.show({
                title: 'Success',
                description: `Partner ${partnerInfo?.id ? 'updated' : 'created'} successfully!`
            })

            setIsCreatingOrUpdatingPartner(false)
            // !partnerId && OnHidePartnerManagement(false)
        }).catch(() => {
            setIsCreatingOrUpdatingPartner(false)
            toast.show({
                title: 'Warning',
                description: `Failed to ${partnerInfo?.id ? 'update' : 'create'} Partner!`
            })
        })
    }

    const handleCancelClick = () => {
        setInitialSupplierInfo(allPartnerColumns, partnerOldInfo)
    }

    const handleChangeCallingScriptInfo = (info) => {
        setCallingScriptInfo(info)
    }

    const handleOnCreateScript = (script) => {
        if (script?.isDefault) {
            setDefaultScript(script)
        }
        if (partnerId || newPartnerId) {
            getAllCallerScripts()
        }
    }

    const status = progress === 100 ? 'success' : null;
    const color = progress === 100 ? '#52c41a' : '#3385ff';

    return (
        <div className='partner-management-page padding-left'>
            <div className='current-page-title d-flex align-items-center gap-3'>
                <MdOutlineArrowBackIosNew color="#78B1E4" size={16} onClick={() => { OnHidePartnerManagement(false) }} />
                Partner Management
            </div>
            <div className={`partner-management-content mt-4 position-relative${(isCreatingOrUpdatingPartner || isGettingPartnerDataById) ? ' loading' : ''}`}>
                {(isCreatingOrUpdatingPartner || isGettingPartnerDataById) && <LoaderComponent />}
                <div className='position-relative'>
                    <div className='general-information border rounded bg-white'>
                        <div className='header d-flex align-items-center p-3 border border-top-0 border-end-0 border-start-0'>
                            <h3 className='mb-0 text-blue fw-bold'>General Information</h3>
                            <div className='ms-auto d-flex gap-2'>
                                <button className='width-100 h4 mb-0 pt-3 pb-3 bg-light-gray text-white rounded' disabled={isGettingPartnerDataById} onClick={handleCancelClick}>Cancel</button>
                                <button className='width-100 h4 mb-0 pt-3 pb-3 btn-green rounded' disabled={isGettingPartnerDataById} onClick={handleSaveSupplierInfo}>Save</button>
                            </div>
                        </div>
                        <div className='content d-flex gap-5 p-4'>
                            <div className='left-content flex-grow-1'>
                                {partnerGeneralInfoLeftCols.map(leftCol => {
                                    return (
                                        <div className='d-flex align-items-center gap-2 mb-4'>
                                            <h4 className='mb-0 text-black col-4'>{leftCol.label}</h4>
                                            {leftCol.name === 'phone' ? (
                                                <div className="phone-input-parent flex align-center">
                                                    <div className='d-flex border rounded phone-input-ext-container w-100 flex-column flex-lg-row'>
                                                        <ReactPhoneInput
                                                            className='phone-input-parent'
                                                            country={'us'}
                                                            value={partnerInfo?.[leftCol.name] || ''}
                                                            onChange={handlePhoneInputChange}
                                                            onBlur={(event, country) => { isPhoneValid === '' && handlePhoneNumberFocusOut(event, country, partnerInfo[leftCol.name]) }}
                                                            countryCodeEditable={false}
                                                            preferredCountries={['us']}
                                                            onKeyDown={(e) => handleKeyDown(e, phoneInputRefname)}
                                                            ref={phoneInputRefname}
                                                            buttonClass='border-0 border-end'
                                                            inputProps={{
                                                                className: 'form-control border-0 shadow-none'
                                                            }}
                                                        />
                                                        <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                            <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                            <input
                                                                type="text"
                                                                className="search-input mt-0 shadow-none border-0 ps-3 pe-3 h4 mb-0"
                                                                placeholder="phone extension"
                                                                value={partnerInfo?.phoneExtension || ''}
                                                                onChange={(e) => { handleChangePartnerInfo('phoneExtension', e.target.value) }}
                                                                disabled={(!partnerInfo?.phone || !isPhoneValid || partnerInfo?.phone === countryCode) ? true : false}
                                                            />
                                                        </div>
                                                    </div>
                                                    {isValidatingPhone && (<Loader />)}
                                                    {partnerInfo[leftCol.name] && !isValidatingPhone && isPhoneValid !== '' &&
                                                        (isPhoneValid ?
                                                            <BsCheckSquare color="#067911" size={26} />
                                                            :
                                                            <BsXSquare color="#f75a52" size={26} />
                                                        )
                                                    }
                                                </div>
                                            ) :
                                                leftCol.name === 'email' ? (
                                                    <div className="phone-input-parent flex align-center">
                                                        <input
                                                            className={`search-input h4 mb-0`}
                                                            type="text"
                                                            value={partnerInfo[leftCol.name] || ''}
                                                            onChange={e => handleChangePartnerInfo(leftCol.name, e.target.value)}
                                                            onBlur={() => { isEmailValid === '' && handleEmailFocusOut(partnerInfo[leftCol.name]) }}
                                                        />
                                                        {isValidatingEmail && (<Loader />)}
                                                        {partnerInfo[leftCol.name] && !isValidatingEmail && isEmailValid !== '' &&
                                                            (isEmailValid ?
                                                                <BsCheckSquare color="#067911" size={26} />
                                                                :
                                                                <BsXSquare color="#f75a52" size={26} />
                                                            )
                                                        }
                                                    </div>
                                                )
                                                    :
                                                    <input
                                                        className='search-input h4 mb-0'
                                                        value={partnerInfo?.[leftCol?.name] || ''}
                                                        onChange={(e) => { handleChangePartnerInfo(leftCol.name, e.target.value) }}
                                                    />
                                            }
                                        </div>
                                    )
                                })}
                            </div>
                            <div className='right-content flex-grow-1'>
                                {partnerGeneralInfoRightCols.map(rightCol => {
                                    return (
                                        <div className='d-flex align-items-center gap-2 mb-4'>
                                            <h4 className='mb-0 text-black col-4'>{rightCol.label}</h4>
                                            <input
                                                className='search-input h4 mb-0'
                                                value={partnerInfo?.[rightCol?.name] || ''}
                                                onChange={(e) => { handleChangePartnerInfo(rightCol.name, e.target.value) }}
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className='partner-preferences border rounded mt-5 bg-white'>
                        <div className='header d-flex align-items-center p-4 border border-top-0 border-end-0 border-start-0'>
                            <h3 className='mb-0 text-blue fw-bold'>Partner Preferences</h3>
                        </div>
                        <div className='content d-flex gap-4 p-4 flex-column'>
                            {
                                logoFile && progress > 0 && (
                                    <Progress.Line percent={progress} strokeColor={color} status={status} />
                                )
                            }

                            <div className='d-flex align-items-center gap-5'>
                                <div className='d-flex align-items-center gap-2 w-50'>
                                    <h4 className='mb-0 text-black col-2'>Rebate</h4>
                                    <input
                                        className='search-input h4 mb-0 w-auto'
                                        value={partnerInfo?.['rebate'] || ''}
                                        onChange={(e) => { handleChangePartnerInfo('rebate', e.target.value) }}
                                    />
                                </div>
                                <div className='d-flex align-items-center gap-2 w-50'>
                                    <h4 className='mb-0 text-black col-3'>Automatable</h4>
                                    <Select
                                        isMulti
                                        isClearable={false}
                                        classNamePrefix='react-select-selector'
                                        className='w-100 h4 mb-0 text-black'
                                        options={automatableOptions.map((option) => (
                                            {
                                                label: option,
                                                value: option.toLowerCase().replaceAll(' ', '-')
                                            }
                                        ))}
                                        value={partnerInfo?.automatableValue || null}
                                        onChange={(item) => { handleChangePartnerInfo('automatableValue', item) }}
                                    />
                                </div>
                            </div>
                            <div className='d-flex flex-column gap-3'>
                                <h4 className='mb-0 text-black col-2'>Upload Logo</h4>
                                <div className="accept-item">
                                    <DragDropFileUpload
                                        currentFileName={logoFile ? logoFile.name : partnerInfo?.logo}
                                        onFileChosen={handleFileChosen}
                                        customClassName='upload-logo'
                                        accept={
                                            [".png", ".gif", ".jpeg", ".jpg", ".svg"]
                                        }
                                        isDownload={(partnerInfo?.logo && logoFile === null) ? true : false}
                                        imageURL={logoURL}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='partner-preferences border rounded mt-5 bg-white'>
                        <div className='header d-flex align-items-center p-4 border border-top-0 border-end-0 border-start-0'>
                            <h3 className='mb-0 text-blue fw-bold'>Card Support</h3>
                        </div>
                        <div className='content d-flex gap-4 p-4 flex-column'>
                            <div className='d-flex align-items-center gap-5'>
                                <div className='d-flex align-items-center gap-2 w-50'>
                                    <h4 className='mb-0 text-black col-2'>BIN Support</h4>
                                    <Select
                                        isMulti
                                        isClearable={false}
                                        classNamePrefix='react-select-selector'
                                        className='w-100 h4 mb-0 text-black'
                                        options={binSupportOptions.map((option) => (
                                            {
                                                label: option,
                                                value: option.toLowerCase().replaceAll(' ', '-')
                                            }
                                        ))}
                                        value={partnerInfo?.binSupportValue || null}
                                        onChange={(item) => { handleChangePartnerInfo('binSupportValue', item) }}
                                    />
                                </div>
                                <div className='d-flex align-items-center gap-2 w-50'>
                                    <h4 className='mb-0 text-black col-3'>Card Program Support</h4>
                                    <Select
                                        isMulti
                                        isClearable={false}
                                        classNamePrefix='react-select-selector'
                                        className='w-100 h4 mb-0 text-black'
                                        options={cardProgramSupportOptions.map((option) => (
                                            {
                                                label: option,
                                                value: option.toLowerCase().replaceAll(' ', '-')
                                            }
                                        ))}
                                        value={partnerInfo?.cardProgramSupportValue || null}
                                        onChange={(item) => { handleChangePartnerInfo('cardProgramSupportValue', item) }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='ms-auto d-flex gap-2 mt-4 justify-content-end position-sticky bottom-0'>
                        <button className='width-100 h4 mb-0 pt-3 pb-3 bg-light-gray text-white rounded' disabled={isGettingPartnerDataById} onClick={handleCancelClick}>Cancel</button>
                        <button className='width-100 h4 mb-0 pt-3 pb-3 btn-green rounded' disabled={isGettingPartnerDataById} onClick={handleSaveSupplierInfo}>Save</button>
                    </div>
                </div>
                <hr className='mt-5' />
                <CreateCallingScriptComponent
                    partnerId={partnerId}
                    partnerName={partnerId ? partnerInfo?.partnerName : ''}
                    defaultScript={defaultScript}
                    isFromPartnerManage={true}
                    isUpdatingPartner={partnerId ? true : false}
                    onCreateScript={handleOnCreateScript}
                    onChangeCallingScriptInfo={handleChangeCallingScriptInfo}
                    isUpdatingScript={false}
                    isDisable={isDisable}
                    newPartnerId={newPartnerId}
                    partnerPage={partnerPage}
                />
                <CallingScriptList
                    partnerId={partnerId || newPartnerId}
                    callingScripts={callingScripts}
                    onChangeCallingScriptInfo={handleChangeCallingScriptInfo}
                    onUpdateScript={handleOnCreateScript}
                    getScripts={handleOnCreateScript}
                    isLoading={isLoading}
                    isDefaultId={isDefaultScriptId}
                    partnerName={partnerId ? partnerInfo?.partnerName : ''}
                />
            </div>
        </div>
    )
}

export default CreateOrUpdatePartnerComponent